import React from 'react';
import { useTranslation } from '../../hooks/useTranslation.jsx';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';
import { Link } from 'react-router-dom';

const { FiUsers, FiEdit3, FiGlobe, FiCheckCircle } = FiIcons;

export default function CommunityPage() {
  const { contentLanguage } = useTranslation();

  const roles = [
    {
      title: { en: 'Content Contributor', el: 'Συνεργάτης Περιεχομένου' },
      desc: { en: 'Share links, resources, and practical tips.', el: 'Μοιραστείτε συνδέσμους, πόρους και πρακτικές συμβουλές.' },
      icon: FiEdit3
    },
    {
      title: { en: 'Translator', el: 'Μεταφραστής' },
      desc: { en: 'Help us make content accessible in more languages.', el: 'Βοηθήστε μας να κάνουμε το περιεχόμενο προσιτό σε περισσότερες γλώσσες.' },
      icon: FiGlobe
    },
    {
      title: { en: 'Medical Reviewer', el: 'Ιατρικός Ελεγκτής' },
      desc: { en: 'Verify medical accuracy for sensitive resources.', el: 'Επαληθεύστε την ιατρική ακρίβεια για ευαίσθητους πόρους.' },
      icon: FiCheckCircle
    }
  ];

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
      <div className="text-center max-w-3xl mx-auto mb-16">
        <div className="inline-flex p-4 bg-blue-50 text-blue-600 rounded-2xl mb-6">
          <SafeIcon icon={FiUsers} className="text-4xl" />
        </div>
        <h1 className="text-4xl md:text-5xl font-black text-gray-900 mb-6">
          {contentLanguage === 'el' ? 'Γίνετε Μέρος της Κοινότητας' : 'Join the Community'}
        </h1>
        <p className="text-xl text-gray-600 leading-relaxed">
          {contentLanguage === 'el'
            ? 'Η πλατφόρμα μας μεγαλώνει χάρη στη δύναμη των εθελοντών. Κάθε συνεισφορά μετράει.'
            : 'Our platform grows thanks to the power of volunteers. Every contribution matters.'}
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
        {roles.map((role, i) => (
          <div key={i} className="bg-white p-8 rounded-3xl border border-gray-100 shadow-sm hover:shadow-md transition-all text-center">
            <div className="w-16 h-16 bg-gray-50 rounded-2xl flex items-center justify-center mx-auto mb-6 text-gray-900">
              <SafeIcon icon={role.icon} className="text-3xl" />
            </div>
            <h3 className="text-xl font-bold mb-3">{role.title[contentLanguage]}</h3>
            <p className="text-gray-500 mb-6">{role.desc[contentLanguage]}</p>
          </div>
        ))}
      </div>

      <div className="bg-gray-900 rounded-3xl p-12 text-white flex flex-col md:flex-row items-center gap-12">
        <div className="flex-grow">
          <h2 className="text-3xl font-bold mb-4">
            {contentLanguage === 'el' ? 'Έτοιμοι να ξεκινήσετε;' : 'Ready to start?'}
          </h2>
          <p className="text-gray-400 text-lg">
            {contentLanguage === 'el'
              ? 'Δημιουργήστε έναν λογαριασμό εθελοντή και ξεκινήστε να συνεισφέρετε στην αποστολή μας.'
              : 'Create a volunteer account and start contributing to our mission.'}
          </p>
        </div>
        <div className="flex-shrink-0 flex gap-4">
          <Link 
            to="/submit"
            className="px-8 py-4 bg-blue-600 text-white font-black rounded-2xl hover:bg-blue-700 transition-all shadow-lg"
          >
            {contentLanguage === 'el' ? 'Υποβολή Τώρα' : 'Submit Now'}
          </Link>
        </div>
      </div>
    </div>
  );
}